import { useIdentityStore } from '~/store/identity'
import { useRootStore } from '~/store/root'
import { useBorrowerStore } from '~/store/borrower'
import { consumeWidgetLoginToken } from '~/composables/identityWidgetLoginUrl'
import { setTrackingCookiesFromParams } from '~/composables/setTrackingCookiesFromParams'

// api's borrower login links (User::borrowerPortalLoginUrl) name the landing
// page as ?r=<page>, e.g. r=upload; the widget forwards it here untouched.
const LOGIN_LINK_PAGE = /^[a-z0-9-]+(\/[a-z0-9-]+)*$/

function loginLinkRedirect(r) {
  return typeof r === 'string' && LOGIN_LINK_PAGE.test(r) ? `/${r}` : null
}

function seedTrackingFromReturnTo(query) {
  useNuxtApp().$lendioCookies.clearTrackingCookies()
  setTrackingCookiesFromParams({ ...query })
  const visitor = Array.isArray(query.visitor) ? query.visitor[0] : query.visitor
  if (visitor) useRootStore().setVisitorId(visitor)
}

// plugins/089.nuxt-server-init.js has already loaded the borrower from the widget's
// session cookie, so the exchange's getBorrower({ touch }) returns early without touching.
async function recordUnconsumedLoginTouch() {
  const { $lendioCookies } = useNuxtApp()
  if (Object.keys($lendioCookies.getTrackingCookies()).length > 0) {
    await useBorrowerStore().addLastTouch()
  }
}

// Must run before 011.auth.global.js's isLoggedIn check, on any route -- the
// widget's token can land on whatever page return_to pointed at.
export default defineNuxtRouteMiddleware(async (to) => {
  const token = consumeWidgetLoginToken()
  if (!token) return

  const pwfReturn = to.query.pwfReturn === '1'
  if (pwfReturn) seedTrackingFromReturnTo(to.query)

  try {
    await useIdentityStore().consumeWidgetToken(token)
    if (pwfReturn) await recordUnconsumedLoginTouch()
  } catch (error) {
    log.error('Failed to exchange identity widget login token', error)
  }

  // No page exists at "/" -- avoid a 404.
  if (to.path === '/') {
    const loginLinkPage = loginLinkRedirect(to.query.r)
    if (loginLinkPage) {
      // 012.business-select.global.js may intercept this navigation; its
      // switchTo() reads the redirect cookie once a business is selected.
      useNuxtApp().$lendioCookies.set('redirect', loginLinkPage, { maxAge: 60 * 10 })
      return navigateTo(loginLinkPage, { replace: true })
    }
    return navigateTo(useRootStore().getRedirectUrl(), { replace: true })
  }
})
